import 'moment';
import timeDepositConstants from '../actiontypes/timeDeposit';
import appModalConstants from '../actiontypes/appModal';
import authActions from './auth.action';
import appModalActions from './appModal.action';
import userActions from './user.action';
import {
  simulate,
  list,
  getById,
  signOn,
  liquidate
} from '../../api/TimeDepositService';
import { getHolidays, getConfigDap } from '../../api/GeneralParamService';
import { countDays } from '../../utils/DateUtil';
import { formatDate } from '../../utils/FormatUtil';

function changeAmount(payload) {
  return dispatch => {
    dispatch({ type: timeDepositConstants.AMOUNT_CHANGED, payload });

    if (payload < 100000) {
      dispatch(this.changeDepositType('R'));
    }
  };
}

function changeTimeLimit(payload) {
  return { type: timeDepositConstants.TIMELIMIT_CHANGED, payload };
}

function changeDepositType(payload) {
  return { type: timeDepositConstants.DEPOSIT_TYPE_CHANGED, payload };
}

function setStep(payload) {
  return { type: timeDepositConstants.STEP_CHANGED, payload };
}

function getSimulation(params) {
  return dispatch => {
    dispatch(
      appModalActions.loadingOn('Estamos calculando su mejor inversión')
    );

    dispatch({ type: timeDepositConstants.SIMULATION_REQUEST });

    simulate(params)
      .then(
        response => {
          dispatch({
            type: timeDepositConstants.SIMULATION_SUCCESS,
            payload: response.data
          });

          dispatch({ type: timeDepositConstants.STEP_CHANGED, payload: 2 });
        },
        error => {
          dispatch({ type: timeDepositConstants.SIMULATION_FAILURE });
          dispatch(appModalActions.openErrorModal(error.data.mensaje));
        }
      )
      .then(() => {
        dispatch(userActions.getPersonalInfo());
      })
      .then(() => {
        dispatch(appModalActions.loadingOff());
      });
  };
}

function listTimeDeposits() {
  return dispatch => {
    dispatch(appModalActions.loadingOn('Obteniendo Información'));

    list()
      .then(
        response => {
          dispatch({
            type: timeDepositConstants.LIST_SUCCESS,
            payload: response.data
          });
          dispatch(
            authActions.setInitPage(
              response.data.length === 0 ? '/simulador' : '/listado'
            )
          );
        },
        error => {
          // TODO: Solución PIRATA. Mejorar en CPB enviando un "status" diferenciado, o un "status" == 2XX
          if (
            error.status === 409 &&
            error.data.mensaje.includes('Registro no existe')
          ) {
            dispatch(authActions.setInitPage('/simulador'));
          } else {
            dispatch({ type: timeDepositConstants.LIST_FAILURE });
            dispatch(appModalActions.openErrorModal(error.data.mensaje));
          }
        }
      )
      .then(() => {
        dispatch(appModalActions.loadingOff());
      });
  };
}

function getTimeDeposit(params) {
  return dispatch => {
    dispatch(appModalActions.loadingOn('Obteniendo Depósito a Plazo'));

    getById(params)
      .then(
        response => {
          dispatch({
            type: timeDepositConstants.TIME_DEPOSIT_SUCCESS,
            payload: response.data
          });

          dispatch(appModalActions.loadingOff());
        },
        error => {
          dispatch({ type: timeDepositConstants.TIME_DEPOSIT_FAILURE });
          dispatch({
            type: appModalConstants.SET_PATH_REDIRECT,
            redirect: '/listado'
          });
          dispatch(appModalActions.openErrorModal(error.data.mensaje));
        }
      )
      .then(() => {
        dispatch(appModalActions.loadingOff());
      });
  };
}

function changeAccountOut(payload) {
  return { type: timeDepositConstants.ACCOUNT_OUT_CHANGED, payload };
}

function changeAccountIn(payload) {
  return { type: timeDepositConstants.ACCOUNT_IN_CHANGED, payload };
}

function changeTerms(payload) {
  return { type: timeDepositConstants.TERMS_CHANGED, payload };
}

function contractTimeDeposit(params) {
  return dispatch => {
    dispatch(
      appModalActions.loadingOn('Contratando su nuevo Depósito a Plazo')
    );

    dispatch({ type: timeDepositConstants.SIGN_IN_REQUEST });

    signOn(params)
      .then(
        response => {
          dispatch({
            type: timeDepositConstants.SIGN_IN_SUCCESS,
            payload: response.data
          });

          dispatch({ type: timeDepositConstants.STEP_CHANGED, payload: 3 });
        },
        error => {
          dispatch({ type: timeDepositConstants.SIGN_IN_FAILURE });
          dispatch(appModalActions.openErrorModal(error.data.mensaje));
        }
      )
      .then(() => {
        dispatch(appModalActions.loadingOff());
      });
  };
}

function cleanSimulation() {
  return { type: timeDepositConstants.SIMULATION_CLEANED };
}

function cleanResult() {
  return { type: timeDepositConstants.RESULT_CLEANED };
}

function liquidateTimeDeposit(params) {
  return dispatch => {
    dispatch({ type: timeDepositConstants.LIQUIDATE_REQUEST });
    dispatch(appModalActions.loadingOn('Liquidando su Depósito a Plazo'));

    liquidate(params)
      .then(
        response => {
          dispatch({
            type: timeDepositConstants.LIQUIDATE_SUCCESS,
            payload: response.data
          });
        },
        error => {
          dispatch({ type: timeDepositConstants.LIQUIDATE_FAILURE });
          dispatch(appModalActions.openErrorModal(error.data.mensaje));
        }
      )
      .then(() => {
        dispatch(appModalActions.loadingOff());
      });
  };
}

function changeAccount(payload) {
  return { type: timeDepositConstants.LIQUIDATE_ACCOUNT_CHANGED, payload };
}

function cleanLiquidate() {
  return { type: timeDepositConstants.LIQUIDATE_CLEANED };
}

function changeExpirationDate(expirationDate, inhabiles) {
  const timeLimit = countDays(new Date(), expirationDate, inhabiles);

  return {
    type: timeDepositConstants.EXPIRATION_DATE_CHANGED,
    expirationDate: formatDate(expirationDate, 'DD/MM/YYYY'),
    timeLimit
  };
}

function setDefaultExpDate(defExpDate) {
  return {
    type: timeDepositConstants.DEF_EXP_DATE_CHANGED,
    defaultExpirationDate: defExpDate
  };
}

function setSimulationSelected(simulationSelected) {
  return {
    type: timeDepositConstants.SIMULATION_SELECTED,
    payload: simulationSelected
  };
}

function getHolidaysDays(params, timeLimit) {
  console.log('timeLimit', timeLimit);
  return dispatch => {
    getHolidays(params).then(
      response => {
        dispatch({
          type: timeDepositConstants.HOLIDAYS_SUCCESS,
          payload: response.data,
          timeLimit: timeLimit === '' ? 0 : timeLimit
        });
      },
      () => {
        dispatch({ type: timeDepositConstants.HOLIDAYS_FAILURE, payload: [] });
      }
    );
  };
}

function setRating(rating) {
  return {
    type: timeDepositConstants.RATING_SELECTED,
    payload: rating
  };
}

function setCommentAssesment(comment) {
  return {
    type: timeDepositConstants.ASSESMENT_COMMENT_CHANGED,
    payload: comment.trim().length > 0 ? comment : ''
  };
}

function getConfiguracionDap() {
  return dispatch => {
    getConfigDap().then(
      response => {
        dispatch({
          type: timeDepositConstants.LOAD_CONFIG_DAP_SUCCESS,
          payload: response.data.montoMaximoInversionDap
        });
      },
      () => {
        dispatch(appModalActions.redirectErrorModal("/listado"));
      }
    );
  };
}

const timeDepositActions = {
  changeAmount,
  changeTimeLimit,
  changeDepositType,
  setStep,
  getSimulation,
  listTimeDeposits,
  getTimeDeposit,
  changeTerms,
  contractTimeDeposit,
  changeAccountOut,
  changeAccountIn,
  cleanSimulation,
  cleanResult,
  liquidateTimeDeposit,
  changeAccount,
  cleanLiquidate,
  changeExpirationDate,
  setSimulationSelected,
  getHolidaysDays,
  setDefaultExpDate,
  setRating,
  setCommentAssesment,
  getConfiguracionDap
};

export default timeDepositActions;
